import React from 'react';
import { HeroHeaderProps, ResponsiveImage, HomeHero } from '@greystar/ui';
import { withDatasourceCheck, Text as JssText } from '@sitecore-jss/sitecore-jss-nextjs';

import {
  SearchBox as HeadlessSearchBox,
  InstantProducts as HeadlessInstantProducts,
  buildStandaloneSearchBox,
  buildInstantProducts,
} from '@coveo/headless/commerce';
import { getEngine } from '@greystar/lib';

const HeroHeader: React.FC<HeroHeaderProps> = (props) => {
  const { title, subTitle, image, searchDropdown, description, secondarySubtitle } =
    props.fields || {};
  const backgroundColor = props?.params?.backgroundColours;

  const isInternalSearchPage = !!description?.value?.length;
  const searchBoxId = props.rendering.uid ?? 'searchBoxHeroHeader';

  const controllerSearchBox: HeadlessSearchBox = buildStandaloneSearchBox(getEngine(), {
    options: {
      redirectionUrl: '/s',
      id: searchBoxId,
    },
  });

  const controllerInstantProducts: HeadlessInstantProducts = buildInstantProducts(getEngine(), {
    options: {
      searchBoxId: searchBoxId,
    },
  });

  return (
    <HomeHero
      controllerSearchBox={controllerSearchBox}
      controllerInstantProducts={controllerInstantProducts}
      title={title ? <JssText field={title} /> : null}
      subtitle={subTitle ? <JssText field={subTitle} /> : null}
      description={description ? <JssText field={description} /> : null}
      internalSearchPage={isInternalSearchPage}
      placeholderText={searchDropdown?.value || ''}
      imageSrc={
        <ResponsiveImage
          priority={!isInternalSearchPage}
          loading={isInternalSearchPage ? 'lazy' : 'eager'}
          width={393}
          height={295}
          sizes="90vw"
          image={image}
          className="object-cover rounded-lg"
        />
      }
      backgroundColor={backgroundColor}
      secondarySubtitle={secondarySubtitle ? <JssText field={secondarySubtitle} /> : null}
    />
  );
};

export default withDatasourceCheck()(HeroHeader);
